/* ============================================================================
   ALIA booking widget — option [A] "The Maitre d'", single widget.
   Theme: r06-olive-branch. Shadow-DOM isolated (no CSS collides either way).

   Every colour below is a verbatim token value from the theme's :root
   (templates/index.liquid), plus the green CTA layer assigned BY ROLE:
   fills are --cta-green, letters on light grounds are --cta-deep, and the
   ink ON a green fill is near-black, never white (3.26:1 fails AA).
   Type is the theme's own Chivo / Chivo Mono, already loaded by the template —
   Shadow DOM blocks inherited styles but not @font-face, so they resolve.

   Priority = Corporate. It opens the lead form; Restaurant books, Club calls.
   Anything on the page carrying [data-alia-lead] opens the same form, and
   keeps its tel: href as the no-JS fallback.

   ---- WIRING (edit these lines only) ---------------------------------------- */
(function () {
  'use strict';

  var CFG = Object.assign({
    phone: '(514) 566-2542',
    phoneHref: 'tel:+15145662542',
    openTable: 'https://www.opentable.ca/r/alia-montreal',

    /* Corporate lead form → the shared ALIA Google Apps Script Web App.
       Live. Every ALIA store posts to this one endpoint, and the receiving
       script builds each row by matching the SHEET'S HEADER TEXT against the
       posted JSON, so the keys in FIELDS below are spelled to match the
       sheet exactly:

         Received | Site | Page | Name | Company | Email | Phone |
         Event type | Event detail | Guests | Preferred date |
         Budget per head | Notes | Status

       "Received" is set by the script itself and is never posted. If a row
       ever arrives with ONLY Received filled, a key stopped matching a
       header — that is the signature of this contract breaking (§7).

       Two deployment settings will otherwise bite you (§7):
         · Access must be "Anyone", NOT "Anyone with a Google account" —
           a visitor is anonymous and the stricter setting returns a login
           page, losing the lead.
         · Apps Script serves the LAST DEPLOYED version, not the last saved
           one. Re-deploy after every edit.

       Blind spot to state to the client: the POST uses mode:'no-cors',
       which Apps Script requires (it cannot answer a CORS preflight), so the
       browser gets an opaque response and cannot read the status. The form
       says "Sent" whenever the request LEAVES the browser — including when
       the script throws or the deployment is stale. THE SHEET IS THE ONLY
       PROOF. Submit one test lead and confirm the row. */
    leadEndpoint: 'https://script.google.com/macros/s/AKfycbymDImriMbjGLCHuvihZT-KhSDkHBb_sdlKqkOeaBY8bV-QbQivPefA2f79lKe5FOvFGw/exec',

    /* Injected from Liquid in layout/theme.liquid — the lead sheet's "Site"
       column must be the STORE NAME. Falls back to the hostname, which is
       useless in a sheet shared across stores. */
    siteName: '',

    /* The theme ships a green Reserve/Call dock bottom-right
       (.alia-cta-dock). The widget stands in the same corner and covers the
       same actions plus Corporate, so the dock is hidden. Set false to keep
       both. */
    hideThemeDock: true
  }, window.ALIA_WIDGET_CONFIG || {});
  /* --------------------------------------------------------------------------- */

  if (document.getElementById('alia-wgt-host')) return;

  /* The lead sheet's row is built by looking up the SHEET'S HEADER TEXT in the
     posted JSON, so every value is sent under both its header name and a
     snake_case key. Sending both costs nothing and makes the widget portable
     across stores whose receiving scripts differ. Getting this wrong shows up
     as rows containing only the server-set timestamp. */
  var FIELDS = [
    ['Name',            'name'],
    ['Company',         'company'],
    ['Email',           'email'],
    ['Phone',           'phone'],
    ['Event type',      'event_type'],
    ['Event detail',    'event_detail'],
    ['Guests',          'guests'],
    ['Preferred date',  'date'],
    ['Budget per head', 'budget'],
    ['Notes',           'notes']
  ];

  var OTHER = 'Something else';

  var CSS = `
  :host{
    /* --- theme tokens, exact values (index.liquid :root) --- */
    --espresso:#584737; --bone:#EEEDE3; --parch:#EAE9DC;
    --amber:#8A5F3A; --roast:#4A331F; --roast2:#241A11; --white:#FFFFFF;
    --ink:#584737;
    --ink-soft:rgba(88,71,55,.72);
    --ink-mut:rgba(88,71,55,.52);
    --ink-faint:rgba(88,71,55,.34);
    --line:rgba(88,71,55,.20);
    --line2:rgba(88,71,55,.11);
    --amber-line:rgba(138,95,58,.42);
    --amber-glow:rgba(138,95,58,.16);
    --bone-soft:rgba(238,237,227,.68);
    --bone-mut:rgba(238,237,227,.44);

    /* the action colour, by role — same values as the page's CTA layer */
    --cta-green:#1FA35B;   /* fills only                          */
    --cta-bright:#27C06D;  /* hover fill                          */
    --cta-deep:#166B41;    /* green letters on light grounds      */
    --cta-ink:#08120B;     /* ink ON a green fill · 5.85:1        */

    /* ---- form tokens, measured against THIS card, not inherited ----
       card is --bone #EEEDE3, so:
         well  #FFFFFF  lighter than the card — a darker well reads as a hole
         rim   #8E8375  3.16:1 vs the card, 3.71:1 vs the well  (>=3:1)
         ph    #6B5B4B  6.52:1 on the well
         lab   #6B5B4B  5.54:1 on the card   (--ink-mut is only 3.33:1)
         err   #8A1E12  7.85:1 on the card                                */
    --well:#FFFFFF; --rim:#8E8375; --ph:#6B5B4B; --lab:#6B5B4B; --err:#8A1E12;

    --fd:'Chivo',sans-serif; --fm:'Chivo Mono',monospace;
    --ease:cubic-bezier(.22,1,.36,1);

    position:fixed;
  inset:0;
  z-index:9999;
  pointer-events:none;
  font-family:var(--fd);
  font-weight:300;
  color:var(--ink);
  line-height:1.72;
  -webkit-font-smoothing:antialiased;
  }
  *{margin:0; padding:0; box-sizing:border-box}
  /* Shadow DOM does not inherit the document's stylesheet, so the site-wide
     scrollbar hide in layout/theme.liquid cannot reach in here. The card can
     still scroll in the tightest landscape cases, and a bar appearing inside
     it would be the one place on the site that still showed one. */
  *{scrollbar-width:none; -ms-overflow-style:none}
  ::-webkit-scrollbar{width:0; height:0; display:none}
button,input,select,textarea{
  font-family:inherit;
  color:inherit;
}

/* =========================================
   CURSOR FIX FOR ALIA FORM
========================================= */

/* Always show the cursor inside the popup */
:host{
  cursor:default !important;
}

.scrim,
.ae{
  cursor:default !important;
}

/* Buttons and links */
button,
a,
.ae button,
.ae a{
  cursor:pointer !important;
}

/* Text fields */
input,
textarea,
.ae input,
.ae textarea{
  cursor:text !important;
}

/* Dropdowns */
select,
.ae select{
  cursor:pointer !important;
}

button{
  background:none;
  border:0;
}
  :focus-visible{outline:2px solid var(--amber); outline-offset:3px}

  /* ============================================================
     THE LAUNCHER  ·  a green circle carrying a "?", bottom right.
     The glyph swaps to "×" when the panel is open.

     The panel opens ABOVE the button (column-reverse) so it grows upward
     instead of shoving itself up the screen and dragging the button with it.

     Ink on the green fill is near-black, never white:
       #08120B on #1FA35B .... 5.85:1
       #08120B on #27C06D .... 8.03:1   (hover BRIGHTENS)
     White would be 3.26:1 and fail.
     ============================================================ */
  .dock{
    position:fixed;
    right:clamp(.9rem,2.5vw,1.6rem);
    bottom:clamp(.9rem,2.5vw,1.6rem);
    /* column, NOT column-reverse. In column-reverse the FIRST child is placed
       at the bottom — which put the panel under the button, and because a
       visibility:hidden panel still occupies layout, it held the button ~250px
       up off the corner even while closed. Plain column puts the panel above
       and leaves the button on the bottom edge where it belongs; the dock is
       anchored by its bottom edge, so the panel still grows upward when it
       opens. (No backticks in this comment — the whole stylesheet lives in a
       JS template literal and one would end the string.) */
    display:flex; flex-direction:column; align-items:flex-end;
    gap:.75rem; pointer-events:none;
  }
  .launch{
    position:relative;   /* the attention ring is ::after with inset:-7px */
    flex:none; width:58px; height:58px; border-radius:50%;
    display:grid; place-items:center;
    background:var(--cta-green); color:var(--cta-ink);
    font-family:var(--fd); font-size:1.55rem; font-weight:400; line-height:1;
    /* the glow is two soft green halos over a neutral drop shadow — the
       shadow keeps the button anchored to the page, the halos make it read
       as lit rather than just coloured */
    box-shadow:0 0 18px 2px rgba(31,163,91,.45),
               0 0 46px 8px rgba(31,163,91,.20),
               0 10px 26px rgba(36,26,17,.32);
    pointer-events:auto;
    opacity:0; transform:translateY(14px) scale(.94);
    transition:opacity .6s ease, transform .5s var(--ease),
               background .35s ease, box-shadow .4s ease;
  }
  /* it breathes once revealed, so the eye catches it without it flashing */
  .launch.revealed{opacity:1; transform:none; animation:glow 3.4s ease-in-out infinite}
  @keyframes glow{
    0%,100%{box-shadow:0 0 16px 2px rgba(31,163,91,.38),
                       0 0 40px 7px rgba(31,163,91,.16),
                       0 10px 26px rgba(36,26,17,.32)}
    50%    {box-shadow:0 0 26px 5px rgba(31,163,91,.66),
                       0 0 64px 12px rgba(31,163,91,.32),
                       0 10px 26px rgba(36,26,17,.32)}
  }
  /* hover and open settle it: a static, brighter glow reads as "engaged",
     and a control the visitor is already touching should stop pulsing */
  .launch:hover,.launch.is-open{animation:none}
  .launch:hover{
    background:var(--cta-bright);
    box-shadow:0 0 24px 4px rgba(39,192,109,.62),
               0 0 66px 12px rgba(39,192,109,.34),
               0 14px 32px rgba(36,26,17,.38);
  }
  .launch.is-open{
    box-shadow:0 0 14px 2px rgba(31,163,91,.34),
               0 10px 26px rgba(36,26,17,.32);
  }
  .launch:active{transform:translateY(1px)}
  .launch .glyph{display:block; transform:translateY(-1px)}
  /* a widening ring on top of the glow, three times on arrival only */
  .launch::after{
    content:""; position:absolute; inset:-7px; border-radius:50%;
    border:1px solid var(--cta-bright); opacity:0; pointer-events:none;
  }
  .launch.revealed:not(.is-open)::after{animation:ping 2.8s ease-out 1.4s 3}
  .launch:hover::after,.launch.is-open::after{animation:none}
  @keyframes ping{
    0%{transform:scale(.72); opacity:0}
    18%{opacity:.8}
    70%,100%{transform:scale(1.35); opacity:0}
  }

  /* ---------- the panel of three actions ---------- */
  .card{
    width:min(292px,calc(100vw - 2rem));
    background:var(--bone);
    border:1px solid var(--line);
    box-shadow:0 20px 50px rgba(88,71,55,.26);
    pointer-events:auto;
    opacity:0; visibility:hidden; transform:translateY(10px);
    transition:opacity .4s ease, transform .45s var(--ease), visibility .45s;
  }
  .card.open{opacity:1; visibility:visible; transform:none}
  /* the .prog scroll bar's gradient, reused as the panel's top rule */
  .card::before{
    content:""; position:absolute; left:-1px; right:-1px; top:-1px; height:2px;
    background:linear-gradient(90deg,var(--amber),var(--espresso));
  }
  .card-head{
    padding:.85rem .9rem .1rem;
  }
  .hi{
    display:block;
    font-family:var(--fm); font-weight:500; font-size:.56rem;
    letter-spacing:.26em; text-transform:uppercase; color:var(--amber);
  }
  .nm{
    display:block;
    font-size:1.02rem; font-weight:400; letter-spacing:.07em;
    text-transform:uppercase; color:var(--espresso); line-height:1.3;
    margin-top:.15rem;
  }

  /* ---------- body ---------- */
  .body{overflow:hidden; min-height:0}
  .body-in{
    padding:.9rem .9rem 1rem;
    border-top:1px solid var(--line2);
    display:flex; flex-direction:column; gap:.5rem;
  }
  .say{font-size:.88rem; color:var(--ink-soft); line-height:1.6}
  .who{
    font-family:var(--fm); font-size:.52rem; letter-spacing:.2em;
    text-transform:uppercase; color:var(--ink-faint);
    margin:.15rem 0 .5rem;
  }

  /* ---------- CTAs — exactly one filled thing per view ---------- */
  .cta{
    position:relative; display:flex; align-items:center; gap:.7em;
    width:100%; overflow:hidden; text-decoration:none;
    font-family:var(--fm); font-weight:500; font-size:.66rem;
    letter-spacing:.2em; text-transform:uppercase;
    padding:.85em 1.05em; border:1px solid transparent;
    transition:color .4s var(--ease), border-color .4s ease, background .35s ease;
  }
  .cta::before{
    content:""; position:absolute; inset:0; transform:scaleX(0);
    transform-origin:left; transition:transform .5s var(--ease); z-index:0;
  }
  .cta:hover::before{transform:scaleX(1)}
  .cta > *{position:relative; z-index:1}
  .cta .arr{margin-left:auto; transition:transform .4s var(--ease)}
  .cta:hover .arr{transform:translateX(6px)}

  .cta.primary{
    background:var(--cta-green); border-color:var(--cta-green); color:var(--cta-ink);
  }
  .cta.primary::before{background:var(--cta-bright)}
  .cta.primary .lab{display:flex; flex-direction:column; line-height:1.25}
  .cta.primary .sub{
    font-size:.5rem; letter-spacing:.22em; color:var(--cta-ink); opacity:.66;
    font-weight:500;
  }
  .cta.primary[disabled]{opacity:.55; cursor:default}

  .cta.pill{
    background:transparent; border-color:var(--line); color:var(--ink-soft);
  }
  .cta.pill::before{background:var(--amber-glow)}
  .cta.pill:hover{border-color:var(--amber); color:var(--roast)}
  .cta.pill .meta{
    margin-left:auto; font-size:.52rem; letter-spacing:.16em;
    color:var(--ink-faint); transition:color .35s ease;
  }
  .cta.pill:hover .meta{color:var(--amber)}

  .fine{
    font-family:var(--fm); font-size:.52rem; letter-spacing:.16em;
    text-transform:uppercase; color:var(--ink-faint);
    margin-top:.2rem; line-height:1.7;
  }

  /* ============================================================
     CORPORATE LEAD FORM  ·  the standalone enquiry-form design,
     adopted verbatim including its palette (client instruction).

     Its tokens are NOT the theme's — this is deliberately a dark form
     inside a parchment widget. Every pair was re-measured here:

       label   brass  #C9A45C on card #17140F ....  7.83:1
       title   cream  #F3EEE1 on card ............ 15.85:1
       sub     dim    #A79E8C on card ............  6.92:1
       value   cream  on well #3D3428 ............ 10.54:1
       placeholder   #BDB4A2 on well .............  5.94:1   (2.69:1 rejected)
       placeholder   on focus well #514534 .......  4.54:1
       rim     brass-edge #7A6437 vs card ........  3.24:1   (WCAG UI minimum)
       error   ember-lit #E0705E on card .........  5.81:1
       jade rail #34A96B vs well .................  4.09:1
       button  ink #04210F on jade ...............  5.72:1
       button  ink on jade-lit #46C983 ...........  8.09:1

     Known soft spots, left as supplied rather than silently recoloured:
       · the rim clears 3:1 against the CARD (3.24) but not against the
         WELL (2.15) — the boundary is carried on one side only
       · .done-fine at brass-edge is 3.24:1, under AA for text
       · .btn-ghost's border is 2.41:1; its LABEL is 8.70:1, so the
         control is still identifiable

     Structural rules kept from the original file, do not "fix" back:
       · the well is LIGHTER than the card — darker reads as a hole
       · state lives on the .field WRAPPER, so source order IS priority
         order, and .is-filled stands down for .is-invalid
       · values at 16px, or iOS zooms the page on focus
     ============================================================ */
  .ae{
    --night:#100E0A; --card:#17140F; --hair:#2A241A;
    --cream:#F3EEE1; --cream-dim:#A79E8C;
    --brass:#C9A45C; --brass-edge:#7A6437; --brass-lit:#9C8046;
    --well:#3D3428; --well-hover:#4A4031; --well-focus:#514534;
    --placeholder:#BDB4A2;
    --jade:#34A96B; --jade-lit:#46C983; --jade-ink:#04210F;
    --ember:#C4713F; --ember-lit:#E0705E;
    --sans:ui-sans-serif,-apple-system,BlinkMacSystemFont,"Helvetica Neue","Segoe UI",Roboto,Arial,sans-serif;
    --mono:ui-monospace,SFMono-Regular,"SF Mono",Menlo,"Cascadia Mono",Consolas,monospace;
    color-scheme:dark;          /* makes the UA draw a LIGHT date-picker glyph */
  }
  /* the UA rule for [hidden] is only display:none, so any author rule setting
     a display value silently outranks it. Guard the whole class of bug once. */
  .ae [hidden]{display:none !important}

  /* ---------- the scrim never scrolls: it would stack its own scrollbar
       beside the page's. The card is capped at the viewport and shrinks to
       fit; fields and the submit button never go. ---------- */
  .scrim{
    position:fixed; inset:0; background:rgba(4,3,2,.78);
    backdrop-filter:blur(6px); -webkit-backdrop-filter:blur(6px);
    display:none; align-items:center; justify-content:center;
    padding:.8rem; overflow:hidden; pointer-events:auto; z-index:20;
  }
  .scrim.on{display:flex}

  .ae{
    position:relative; width:min(660px,100%);
    max-height:calc(100dvh - 1.6rem); max-height:calc(100vh - 1.6rem);
    overflow-y:auto; overscroll-behavior:contain;
    background:var(--card); color:var(--cream);
    font-family:var(--sans); font-size:16px; line-height:1.6;
    border:1px solid var(--hair); border-top:2px solid var(--jade);
    border-radius:5px;
    box-shadow:0 30px 80px rgba(0,0,0,.6);
    -webkit-font-smoothing:antialiased;
    animation:rise .45s var(--ease);
  }
  @keyframes rise{from{opacity:0; transform:translateY(16px)} to{opacity:1; transform:none}}
  .ae :focus-visible{outline:2px solid var(--jade-lit); outline-offset:3px; border-radius:3px}
  .ae ::selection{background:var(--jade); color:var(--jade-ink)}

  /* Every vertical metric is tied to viewport height, so the card scales
     smoothly instead of stepping. Stepped breakpoints left stranded bands:
     the conditional Event detail field adds ~86px, and whichever stage was
     active simply had no more to give until the next step fired. */
  .ae-head{padding:clamp(10px,2.1vh,26px) 28px clamp(8px,1.7vh,20px); border-bottom:1px solid var(--hair)}
  .ae-eyebrow{
    font-family:var(--mono); font-size:11px; letter-spacing:.28em;
    text-transform:uppercase; color:var(--brass); margin:0;
  }
  .ae-title{font-size:clamp(1.15rem,2.7vh,1.6rem); font-weight:300; letter-spacing:-.02em; margin:clamp(2px,.6vh,6px) 0; line-height:1.15}
  .ae-sub{margin:0; font-size:14px; color:var(--cream-dim); max-width:46ch}
  .ae-body{padding:clamp(12px,2.3vh,24px) 28px clamp(14px,2.7vh,28px)}

  /* ---------- field grid ---------- */
  .ae-grid{display:grid; grid-template-columns:1fr 1fr; gap:clamp(6px,1.5vh,15px)}
  .ae-span2{grid-column:1 / -1}
  /* The pairs stay two-up at EVERY width. Collapsing to one column on mobile
     doubles the row count and overflowed the card by 190-248px at every width
     from 320 to 620 — the form scrolled on every phone. Two columns give a
     122px field at 320px wide, which every control here renders in cleanly
     (the date input measures 122px and does not clip). Only Event detail and
     Notes take the full width, via .ae-span2. */

  .field{display:flex; flex-direction:column; gap:clamp(3px,.75vh,7px); min-width:0; position:relative}
  .field > label{
    font-family:var(--mono); font-size:10.5px; letter-spacing:.2em;
    text-transform:uppercase; color:var(--brass);
  }
  .field .opt{color:var(--brass-edge)}
  /* "BUDGET PER HEAD (OPTIONAL)" wraps to two lines in any column under about
     200px, which pushed its own control one line lower than its row-mate's and
     left the two inputs in that row visibly out of line. The grid already
     stretches both fields to the same height, so pushing the control to the
     bottom of that box realigns them whatever the labels do. */
  .field input,.field select,.field textarea{margin-top:auto}

  /* REST — the well is lighter than the card behind it */
  .field input,.field select,.field textarea{
    font-family:var(--sans); font-size:16px; color:var(--cream);
    background:var(--well); border:0; border-radius:4px;
    padding:clamp(6px,1.25vh,13px) 14px; width:100%;
    box-shadow:inset 0 0 0 1px var(--brass-edge),
               inset 0 1px 0 var(--brass-lit),
               0 1px 0 rgba(0,0,0,.5),
               0 4px 12px -6px rgba(0,0,0,.7);
    transition:background .16s ease, box-shadow .16s ease;
  }
  /* height, not min-height: a textarea cannot be pulled below its rows
     attribute by min-height, which is why it stuck at 73px before */
  .field textarea{resize:vertical; min-height:0; height:clamp(34px,8vh,88px); font-size:15px; line-height:1.55}
  .field input::placeholder,.field textarea::placeholder{color:var(--placeholder); opacity:1}

  /* HOVER */
  .field input:hover,.field select:hover,.field textarea:hover{
    background:var(--well-hover);
    box-shadow:inset 0 0 0 1px var(--brass-lit), inset 0 1px 0 #B08F4E,
               0 1px 0 rgba(0,0,0,.5), 0 4px 12px -6px rgba(0,0,0,.7);
  }

  /* FOCUS */
  .field input:focus,.field select:focus,.field textarea:focus{
    outline:none; background:var(--well-focus);
    box-shadow:inset 0 0 0 2px var(--jade-lit), 0 0 0 4px rgba(52,169,107,.16);
  }

  /* FILLED — a jade rail marks a field that holds an answer, so completeness
     reads straight down the form. Without the :not(), a malformed email that
     is also focused outranks the error and wears the success ring while wrong. */
  .field.is-filled:not(.is-invalid) input,
  .field.is-filled:not(.is-invalid) select,
  .field.is-filled:not(.is-invalid) textarea{
    box-shadow:inset 4px 0 0 var(--jade), inset 0 0 0 1px var(--brass-edge),
               inset 0 1px 0 var(--brass-lit), 0 1px 0 rgba(0,0,0,.5);
  }
  .field.is-filled:not(.is-invalid) input:focus,
  .field.is-filled:not(.is-invalid) select:focus,
  .field.is-filled:not(.is-invalid) textarea:focus{
    box-shadow:inset 4px 0 0 var(--jade), inset 0 0 0 2px var(--jade-lit),
               0 0 0 4px rgba(52,169,107,.16);
  }

  /* INVALID */
  .field.is-invalid input,.field.is-invalid select,.field.is-invalid textarea{
    box-shadow:inset 4px 0 0 var(--ember), inset 0 0 0 1px #B4523C, 0 1px 0 rgba(0,0,0,.5);
  }
  .field.is-invalid input:focus,.field.is-invalid select:focus,.field.is-invalid textarea:focus{
    box-shadow:inset 4px 0 0 var(--ember), inset 0 0 0 2px var(--ember),
               0 0 0 4px rgba(196,113,63,.18);
  }
  .err{
    display:none; font-family:var(--mono); font-size:10.5px; letter-spacing:.1em;
    color:var(--ember-lit); text-transform:uppercase;
  }
  .field.is-invalid .err{display:block}

  /* native control quirks — an EMPTY date input paints its hint at full text
     colour, so the one blank required field reads as the most complete */
  .field:not(.is-filled) input[type="date"]{color:var(--placeholder)}
  .field input[type="number"]{-moz-appearance:textfield; appearance:textfield}
  .field input[type="number"]::-webkit-outer-spin-button,
  .field input[type="number"]::-webkit-inner-spin-button{-webkit-appearance:none; margin:0}
  .field select{appearance:none; cursor:pointer; padding-right:34px}
  .select-wrap{position:relative}
  .select-wrap::after{
    content:"⌄"; position:absolute; right:13px; bottom:12px;
    color:var(--brass); pointer-events:none; font-size:12px;
  }
  /* Chrome paints autofill with its own background unless a large inset shadow
     covers it, and box-shadow paints the FIRST layer on top, so the covering
     fill has to be the LAST layer. */
  .field input:-webkit-autofill{
    -webkit-text-fill-color:var(--cream);
    transition:background-color 8000s ease-in-out 0s;
    -webkit-box-shadow:inset 0 0 0 1px var(--brass-edge),
                       inset 0 1px 0 var(--brass-lit),
                       inset 0 0 0 100px var(--well);
  }

  /* ---------- footer + button ---------- */
  .ae-foot{
    display:flex; align-items:center; justify-content:space-between; gap:16px;
    flex-wrap:wrap; margin-top:clamp(9px,2.1vh,22px); padding-top:clamp(9px,1.9vh,20px); border-top:1px solid var(--hair);
  }
  .ae-foot p{margin:0; font-size:12.5px; color:var(--cream-dim); max-width:34ch}
  .ae .btn{
    font-family:var(--mono); font-size:11.5px; letter-spacing:.16em;
    text-transform:uppercase; text-decoration:none; white-space:nowrap;
    border-radius:4px; padding:clamp(9px,1.4vh,12px) 18px; cursor:pointer;
    display:inline-flex; align-items:center; gap:8px;
    border:1px solid var(--jade); background:var(--jade); color:var(--jade-ink); font-weight:700;
    transition:background .16s ease, box-shadow .2s ease, transform .16s ease;
  }
  .ae .btn:hover{background:var(--jade-lit); box-shadow:0 6px 26px -8px rgba(52,169,107,.8)}
  .ae .btn:active{transform:translateY(1px)}
  .ae .btn[disabled]{opacity:.6; cursor:progress}
  .ae .btn-ghost{background:transparent; color:var(--jade-lit); border-color:#1D5F3D; font-weight:400}
  .ae .btn-ghost:hover{background:rgba(52,169,107,.1); border-color:var(--jade); box-shadow:none}

  .m-close{
    position:absolute; top:14px; right:14px; width:34px; height:34px;
    display:grid; place-items:center; color:var(--cream-dim); font-size:1rem;
    border:1px solid var(--hair); border-radius:4px; background:transparent;
    transition:color .2s ease, border-color .2s ease;
  }
  .m-close:hover{color:var(--cream); border-color:var(--brass-edge)}

  /* ---------- what is left of the ladder ----------
     The metrics above are clamped to viewport height, so they compress
     continuously and no band is ever stranded. Only the two DISCRETE
     decisions remain here: supporting copy is dropped when the card would
     otherwise stop fitting. The nine fields, the conditional tenth and the
     submit button never go.

     Thresholds are raised for .has-detail — the conditional Event detail
     field adds roughly 86px, so that state has to shed copy sooner. The
     class is set by syncDetail() alongside the field itself. */
  @media(max-height:700px){ .ae-sub{display:none} }
  @media(max-height:600px){ .ae-foot p{display:none} }
  .ae.has-detail .ae-sub{display:none}
  @media(max-height:660px){ .ae.has-detail .ae-foot p{display:none} }
  /* and the metrics run a little tighter for the whole of that state, at
     every height — proportional compression rather than another step */
  .ae.has-detail .ae-grid{gap:clamp(5px,1.2vh,13px)}
  .ae.has-detail .field{gap:clamp(2px,.6vh,6px)}
  .ae.has-detail .field input,
  .ae.has-detail .field select,
  .ae.has-detail .field textarea{padding:clamp(5px,1.05vh,12px) 14px}
  .ae.has-detail .field textarea{height:clamp(30px,6.6vh,74px)}
  .ae.has-detail .ae-title{font-size:clamp(1.1rem,2.4vh,1.5rem)}
  /* ---------- confirmation, in place of the form ---------- */
  /* NO padding here. The element is <div class="ae-body done">, and .ae-body
     already owns the padding — but both are single-class selectors, so the
     one declared later simply wins. This block used to set
     padding 8px 0 4px, which zeroed the 28px horizontal padding and left
     the whole confirmation flush against the card edge. Worse, the two
     .ae-body overrides in the height media queries sit either side of this
     rule in source order, so the bug appeared and disappeared depending on
     the viewport. Padding belongs to .ae-body alone. */
  .done{display:none; flex-direction:column; gap:16px}
  .done.on{display:flex}
  .done-mark{
    width:46px; height:46px; border-radius:50%; background:var(--jade);
    color:var(--jade-ink); display:grid; place-items:center; font-size:22px; font-weight:700;
  }
  .done-h{font-size:1.7rem; font-weight:300; letter-spacing:-.02em; margin:0 0 10px; line-height:1.1}
  .done-lede{margin:0; color:var(--cream-dim); font-size:15px; max-width:48ch}
  .done-lede b{color:var(--cream); font-weight:600}
  .summary{
    display:grid; gap:1px; background:var(--hair);
    border:1px solid var(--hair); border-radius:3px; overflow:hidden; margin:0;
  }
  .summary > div{
    background:var(--night); padding:11px 15px; display:flex;
    justify-content:space-between; gap:18px; font-size:13.5px;
  }
  .summary dt{
    font-family:var(--mono); font-size:10.5px; letter-spacing:.18em;
    text-transform:uppercase; color:var(--brass);
  }
  .summary dd{margin:0; text-align:right; color:var(--cream); overflow-wrap:anywhere}
  .done-next{border-top:1px solid var(--hair); padding-top:18px; display:flex; flex-direction:column; gap:12px}
  .done-actions{display:flex; gap:10px; flex-wrap:wrap}
  /* was --brass-edge, which is 3.24:1 on the card — under AA for text.
     --cream-dim is 6.92:1 and is what the rest of the secondary copy uses. */
  .done-fine{margin:0; font-size:12.5px; color:var(--cream-dim); max-width:52ch}

  /* Mobile keeps the tighter SIDE padding but must keep its vertical metrics
     tied to vh. The old rule here set all four sides to fixed pixels, which
     silently switched the whole shrink-to-fit system off on exactly the
     screens that need it: a 480px-tall viewport got the same 18px/22px as a
     900px one. Only the horizontal values are constants now. */
  @media(max-width:620px){
    .ae-head{padding:clamp(10px,2.1vh,18px) 20px clamp(8px,1.7vh,15px)}
    .ae-body{padding:clamp(12px,2.3vh,18px) 20px clamp(14px,2.7vh,22px)}
    .ae-title{font-size:clamp(1.05rem,2.7vh,1.35rem)}
  }
  /* Narrow phones. The label tracking is the reason "PREFERRED DATE" and
     "BUDGET PER HEAD" wrapped to two lines in a 122px column, costing 34px of
     height on that row; .08em holds them on one line. Reclaiming 6px of side
     padding widens every field by 12px on top of that. */
  @media(max-width:400px){
    .ae-head,.ae-body{padding-left:14px; padding-right:14px}
    .field > label{font-size:10px; letter-spacing:.08em}
    .field input,.field select,.field textarea{padding-left:10px; padding-right:8px}
  }
  /* Landscape phones invert the problem: a 667x375 viewport is wide but leaves
     the card only 349px of height. Width is the abundant axis there, so the
     short fields go three-up (one row fewer) and the head drops to its title.
     This does not fully clear a 375px-tall viewport - ten fields, a heading and
     a submit button do not fit in 349px at a 16px control size, and 16px is a
     floor because a smaller one makes iOS zoom the page on focus. It scrolls
     within the card, contained, rather than overflowing the layout. */
  @media(max-height:520px) and (min-width:640px){
    .ae-grid{grid-template-columns:repeat(3,1fr)}
    .ae-eyebrow,.ae-sub{display:none}
    .ae-head{padding-top:clamp(8px,1.6vh,14px); padding-bottom:clamp(6px,1.4vh,12px)}
    /* Event detail drops out of its full-width row and sits inline. Across
       three columns the eight short fields leave one cell free on their last
       row, so showing the conditional field costs no extra height at all -
       which is where most of the landscape overflow was coming from. */
    .field[data-field="event_detail"]{grid-column:auto}
    .field textarea{height:clamp(30px,7vh,88px)}
    /* The scrim's own inset costs 25px of card height at a viewport that has
       none to spare. Halving it is free - it takes nothing from the controls,
       so the touch targets keep their size. */
    .scrim{padding:.4rem}
    .ae{max-height:calc(100dvh - .8rem); max-height:calc(100vh - .8rem)}
    .ae-grid{gap:4px}
    .field{gap:2px}
  }
  @media(prefers-reduced-motion:reduce){
    .ae,.ae *{transition-duration:.001ms !important; animation-duration:.001ms !important}
  }

  /* ---------- toast (matches the theme's .toast) ----------
     The hidden offset must clear its own height AND the bottom:2rem inset;
     translateY(140%) leaves a short toast permanently visible. */
  .toast{
    position:fixed; left:50%; bottom:2rem;
    transform:translateX(-50%) translateY(calc(100% + 2rem + 4px));
    background:var(--espresso); color:var(--bone);
    font-family:var(--fm); font-size:.66rem; letter-spacing:.16em; text-transform:uppercase;
    padding:.9em 1.5em; border:1px solid var(--amber-line);
    pointer-events:none; visibility:hidden; z-index:30;
    transition:transform .6s var(--ease), visibility .6s;
  }
  .toast.on{transform:translateX(-50%) translateY(0); visibility:visible}
  .toast b{color:var(--amber); font-weight:500}

  @media(max-width:600px){
    .card.open{left:clamp(.9rem,2.5vw,1.6rem); width:auto}
  }
  /* .chev / .head / .sprig / .modal were dropped with the old card launcher;
     their rules went with them rather than being left as orphans (trap #14) */
  @media(prefers-reduced-motion:reduce){
    .card,.card::before,.cta,.cta::before,.launch{transition:none !important}
    /* the breathing glow and the arrival ring both stop. The button keeps its
       resting halo, so it still reads as lit — it just stops moving. */
    .launch,.launch::after{animation:none !important}
    .toast{transition:opacity .2s ease}
  }
  `;

  function field(id, name, label, input, cls) {
    return '<div class="field ' + (cls || '') + '" data-field="' + name + '">' +
      '<label for="alia-f-' + id + '">' + label + '</label>' + input +
      '<span class="err" data-err></span></div>';
  }
  /* a <select> needs the wrapper so ::after can paint the chevron over it */
  function sel(id, name, label, options, cls) {
    return field(id, name, label, '<div class="select-wrap"><select id="alia-f-' + id +
      '" name="' + name + '">' + options + '</select></div>', cls);
  }
  var OPT = ' <span class="opt">(optional)</span>';

  var FORM = [
    '<div class="ae-grid">',

    field('name', 'name', 'Your name',
      '<input id="alia-f-name" name="name" type="text" required autocomplete="name" placeholder="Alex Tremblay">'),
    field('co', 'company', 'Company',
      '<input id="alia-f-co" name="company" type="text" autocomplete="organization" placeholder="Northbound Capital">'),

    field('email', 'email', 'Work email',
      '<input id="alia-f-email" name="email" type="email" required autocomplete="email" placeholder="alex@northbound.ca">'),
    field('phone', 'phone', 'Phone',
      '<input id="alia-f-phone" name="phone" type="tel" autocomplete="tel" placeholder="514 000 0000">'),

    /* the placeholder <option> MUST carry value="" or an untouched select
       reports itself as an answer */
    sel('type', 'event_type', 'Event',
      '<option value="" selected>Choose one</option>' +
      '<option>Conference</option>' +
      '<option>Product launch</option>' +
      '<option>Client day</option>' +
      '<option>Full buyout</option>' +
      '<option>Cocktail reception</option>' +
      '<option>Year-end party</option>' +
      '<option>' + OTHER + '</option>'),

    /* No max on guests. The room is 350 to 400 inside and 150 to 170 outside,
       and a whole-floor buyout can exceed either figure — a max would reject
       exactly the largest enquiries. The two are never summed (§2). */
    field('guests', 'guests', 'Guests',
      '<input id="alia-f-guests" name="guests" type="number" min="1" inputmode="numeric" placeholder="60">'),

    /* shown only when Event is "Something else". `required` is toggled WITH
       visibility — a hidden required field blocks submission with nothing on
       screen to explain why (trap #12). */
    field('detail', 'event_detail', 'Event detail',
      '<input id="alia-f-detail" name="event_detail" type="text" placeholder="Tell us what the day is">',
      'ae-span2'),

    field('date', 'date', 'Preferred date',
      '<input id="alia-f-date" name="date" type="date">', 'f-date'),

    sel('budget', 'budget', 'Budget per head' + OPT,
      '<option value="" selected>Not sure yet</option>' +
      '<option>$95 to $150</option>' +
      '<option>$150 to $225</option>' +
      '<option>$225 and up</option>'),

    field('notes', 'notes', 'Anything we should know' + OPT,
      '<textarea id="alia-f-notes" name="notes" placeholder="Run of day, AV needs, a speech, a hard end time."></textarea>',
      'ae-span2'),

    '</div>'
  ].join('');

  var HTML = `
  <div class="dock">
    <!-- The panel is FIRST in the DOM and the button second; the dock is
         column-reverse, so the button sits at the bottom and the panel grows
         upward out of it. Source order also means Tab reaches the button
         before the panel it controls. -->
    <div class="card" data-card id="alia-wgt-body">
      <div class="card-head">
        <span class="hi">Alia &middot; Reservez</span>
        <span class="nm">Maitre d'</span>
      </div>

      <div class="body">
        <div class="body-in">
          <p class="say">&ldquo;Good day. Which room are we planning?&rdquo;</p>

          <button class="cta primary" data-act="corp">
            <span class="lab"><span class="sub">Priority</span>Corporate &middot; Private events</span>
            <span class="arr">&rsaquo;</span>
          </button>

          <a class="cta pill" data-act="rest" href="${CFG.openTable}" target="_blank" rel="noopener">
            <span>Restaurant &middot; Book</span>
            <span class="meta">OpenTable</span>
          </a>

          <a class="cta pill" data-act="club" href="${CFG.phoneHref}">
            <span>Club &middot; Call</span>
            <span class="meta">${CFG.phone}</span>
          </a>

          <p class="fine">997 Rue Saint-Jacques &middot; 350 to 400 inside</p>
        </div>
      </div>
    </div>

    <button class="launch" data-toggle aria-expanded="false" aria-controls="alia-wgt-body" aria-label="Ways to reach Alia">
      <span class="glyph" data-glyph aria-hidden="true">?</span>
    </button>
  </div>

  <div class="scrim" data-scrim>
    <section class="ae" role="dialog" aria-modal="true" aria-labelledby="alia-wgt-mt">
      <button class="m-close" data-mclose aria-label="Close">&#10005;</button>

      <div data-ask>
        <div class="ae-head">
          <p class="ae-eyebrow">Private events</p>
          <h2 class="ae-title" id="alia-wgt-mt">Request a date</h2>
          <p class="ae-sub">350 to 400 inside, 150 to 170 outside, turn key. The planner comes back within one business day with the room, the timeline and the number.</p>
        </div>

        <div class="ae-body">
          <!-- novalidate: validation is run here so the wording and the error
               styling stay in step, and so the conditional field can join in -->
          <form data-form novalidate>
            ${FORM}
            <div class="ae-foot">
              <p>We hold provisional dates for 48 hours, no deposit.</p>
              <button class="btn" type="submit" data-msubmit>
                <span data-submit-label>Send request</span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="ae-body done" data-done aria-live="polite">
        <div class="done-mark" aria-hidden="true">&#10003;</div>
        <div>
          <h3 class="done-h">Thank you, <span data-done-name></span></h3>
          <p class="done-lede" data-done-lede></p>
        </div>
        <dl class="summary" data-done-grid></dl>
        <div class="done-next">
          <p class="ae-eyebrow">If you need us sooner</p>
          <div class="done-actions">
            <a class="btn btn-ghost" href="${CFG.phoneHref}">Call ${CFG.phone}</a>
          </div>
          <p class="done-fine">Your request is with the events team. We answer every enquiry within one business day.</p>
        </div>
      </div>
    </section>
  </div>

  <div class="toast" data-toast role="status" aria-live="polite"></div>
  `;

  var host = document.createElement('div');
  host.id = 'alia-wgt-host';
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: 'open' });
  root.innerHTML = '<style>' + CSS + '</style>' + HTML;

  var card = root.querySelector('[data-card]');
  var toggle = root.querySelector('[data-toggle]');
  var glyph = root.querySelector('[data-glyph]');
  var scrim = root.querySelector('[data-scrim]');
  var modal = root.querySelector('.ae');
  var toast = root.querySelector('[data-toast]');
  var form = root.querySelector('[data-form]');
  var ask = root.querySelector('[data-ask]');
  var done = root.querySelector('[data-done]');
  var detailField = root.querySelector('[data-field="event_detail"]');
  var detailInput = root.querySelector('#alia-f-detail');
  var typeSelect = root.querySelector('#alia-f-type');
  var lastFocus = null;
  var tTimer;

  /* ---- theme's sticky dock stands down ---- */
  if (CFG.hideThemeDock) {
    var hide = document.createElement('style');
    hide.id = 'alia-wgt-dock-hide';
    hide.textContent = '.alia-cta-dock{display:none !important}';
    document.head.appendChild(hide);
  }

  /* ---- mirror the theme's custom cursor into the shadow root ---- */
  function syncCursor() {
    host.classList.toggle('cursor-none', document.documentElement.classList.contains('has-cursor'));
  }
  syncCursor();
  if (window.MutationObserver) {
    new MutationObserver(syncCursor).observe(document.documentElement, {
      attributes: true, attributeFilter: ['class']
    });
  }

  /* ---- toast ---- */
  function showToast(html) {
    toast.innerHTML = html;                 /* constants only — never user input */
    toast.classList.add('on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  }

  /* ---- card open / close ---- */
  function setOpen(on) {
    card.classList.toggle('open', on);
    toggle.classList.toggle('is-open', on);
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    toggle.setAttribute('aria-label', on ? 'Close' : 'Ways to reach Alia');
    /* the glyph swaps to a cross while the panel is open */
    if (glyph) glyph.textContent = on ? '×' : '?';
  }
  toggle.addEventListener('click', function () {
    setOpen(!card.classList.contains('open'));
  });

  /* ---- page lock: compensate the scrollbar so nothing jumps sideways ---- */
  var lockedPad = '';
  function lockPage(on) {
    var el = document.documentElement;
    if (on) {
      var sb = window.innerWidth - el.clientWidth;
      lockedPad = document.body.style.paddingRight;
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
      el.style.overflow = 'hidden';
      if (window.__aliaLenis) { try { window.__aliaLenis.stop(); } catch (e) {} }
    } else {
      el.style.overflow = '';
      document.body.style.paddingRight = lockedPad;
      if (window.__aliaLenis) { try { window.__aliaLenis.start(); } catch (e) {} }
    }
  }

  /* ---- modal ---- */
  function openModal() {
    lastFocus = document.activeElement;
    scrim.classList.add('on');
    lockPage(true);
    modal.scrollTop = 0;
    var first = root.querySelector('#alia-f-name');
    if (first) setTimeout(function () { first.focus(); }, 60);
  }
  function closeModal() {
    scrim.classList.remove('on');
    lockPage(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelector('[data-mclose]').addEventListener('click', closeModal);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (scrim.classList.contains('on')) closeModal();
    else if (card.classList.contains('open')) setOpen(false);
  });

  /* ---- actions inside the card ---- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!b) return;
    var a = b.getAttribute('data-act');
    if (a === 'corp') { resetForm(); openModal(); return; }
    /* club + rest are real anchors (tel: / OpenTable) — let them through and
       just narrate what is happening */
    if (a === 'club') showToast('<b>Calling</b> ' + CFG.phone);
    else if (a === 'rest') showToast('<b>OpenTable</b> opening in a new tab');
  });

  /* ---- anything on the PAGE carrying [data-alia-lead] opens the same form.
         Delegated on document so it survives Shopify section reloads. The
         element keeps its tel: href as the no-JS fallback. ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-alia-lead]') : null;
    if (!t) return;
    e.preventDefault();
    resetForm();
    openModal();
  });

  /* ============================ field state ============================ */
  function wrapOf(el) { return el.closest('.field'); }
  function isBlank(el) { return el.value.trim() === ''; }

  function validate(el, showError) {
    var w = wrapOf(el); if (!w) return true;
    var errEl = w.querySelector('[data-err]');
    var required = el.hasAttribute('required');
    var v = el.value.trim();
    var msg = '';

    if (required && v === '') msg = 'Required';
    else if (v !== '' && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = 'Check this email address';
    else if (v !== '' && el.type === 'number' && Number(v) < 1) msg = 'At least one guest';
    /* the min attribute is only a hint — an older browser, or anyone editing
       the DOM, can still submit a past date. ISO strings compare correctly as
       plain strings, so no Date object is needed here. */
    else if (v !== '' && el.type === 'date' && v < todayLocal()) msg = 'Choose today or a later date';

    w.classList.toggle('is-filled', v !== '');
    if (msg && showError) {
      w.classList.add('is-invalid');
      if (errEl) errEl.textContent = msg;          /* textContent, never innerHTML */
      el.setAttribute('aria-invalid', 'true');
    } else {
      w.classList.remove('is-invalid');
      if (errEl) errEl.textContent = '';
      el.removeAttribute('aria-invalid');
    }
    return !msg;
  }

  /* Leaving a field you never typed in is not a mistake yet. Blur used to call
     validate(el, true) unconditionally, so tabbing - or on a phone, tapping -
     through the form lit "REQUIRED" under every empty field before anyone had
     done anything wrong, which is what the form looked like on first contact.
     An error now appears on blur only if there is something in the field to be
     wrong about; every empty required field still lights up on submit, where
     the message is earned and actionable. */
  var submitTried = false;
  function shouldWarn(el) { return submitTried || !isBlank(el); }

  var controls = Array.prototype.slice.call(form.querySelectorAll('input,select,textarea'));
  controls.forEach(function (el) {
    var w = wrapOf(el);
    el.addEventListener('focus', function () { w.classList.add('is-focus'); });
    el.addEventListener('blur', function () { w.classList.remove('is-focus'); validate(el, shouldWarn(el)); });
    el.addEventListener('input', function () {
      w.classList.toggle('is-filled', !isBlank(el));
      if (w.classList.contains('is-invalid')) validate(el, true);   /* clear as they fix it */
    });
    el.addEventListener('mouseenter', function () { w.classList.add('is-hover'); });
    el.addEventListener('mouseleave', function () { w.classList.remove('is-hover'); });
    el.addEventListener('change', function () { validate(el, shouldWarn(el)); });
  });

  /* Event detail: visibility and `required` are toggled TOGETHER. A hidden
     required field blocks checkValidity() with nothing on screen to explain
     why (trap #12). */
  function syncDetail() {
    var on = typeSelect.value === OTHER;
    detailField.hidden = !on;
    /* the extra row costs ~86px, so the card sheds its supporting copy
       sooner while it is showing (see .has-detail in the stylesheet) */
    if (modal) modal.classList.toggle('has-detail', on);
    if (on) detailInput.setAttribute('required', 'required');
    else {
      detailInput.removeAttribute('required');
      detailInput.value = '';
      detailField.classList.remove('is-invalid', 'is-filled', 'is-focus');
      var e = detailField.querySelector('[data-err]'); if (e) e.textContent = '';
    }
  }
  typeSelect.addEventListener('change', syncDetail);
  syncDetail();

  /* form.reset() clears values but NOT wrapper classes — reset those too or
     the next open shows success rings on empty fields (trap #11). */
  function resetForm() {
    form.reset();
    Array.prototype.forEach.call(form.querySelectorAll('.field'), function (w) {
      w.classList.remove('is-filled', 'is-invalid', 'is-focus', 'is-hover');
      var e = w.querySelector('[data-err]'); if (e) e.textContent = '';
    });
    controls.forEach(function (el) { el.removeAttribute('aria-invalid'); });
    syncDetail();
    done.classList.remove('on');
    ask.style.display = '';
    var btn = form.querySelector('[data-msubmit]');
    var label = form.querySelector('[data-submit-label]');
    if (btn) btn.disabled = false;
    if (label) label.textContent = 'Send request';
  }

  /* ---- a date in the past helps nobody ----
     Built from the LOCAL date parts, not toISOString(): that converts to UTC,
     so any evening in Montreal (UTC-4/-5) reports tomorrow's date and would
     block today. Same trap as trap #10, in the other direction. */
  function todayLocal() {
    var d = new Date();
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  var dateInput = root.querySelector('#alia-f-date');
  if (dateInput) dateInput.setAttribute('min', todayLocal());

  /* 'YYYY-MM-DD' passed to new Date() parses as UTC and renders as the
     previous day west of Greenwich. Split it and construct locally. */
  function prettyDate(iso) {
    if (!iso) return '';
    var p = String(iso).split('-');
    if (p.length !== 3) return iso;
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    if (isNaN(d.getTime())) return iso;
    try {
      return d.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { return iso; }
  }

  /* ---- confirmation, in place of the form ---- */
  function showDone(values) {
    var first = (values.name || '').trim().split(/\s+/)[0] || 'there';
    root.querySelector('[data-done-name]').textContent = first;   /* textContent (trap #13) */

    var bits = [];
    if (values.guests) bits.push(values.guests + ' guests');
    if (values.date) bits.push(prettyDate(values.date));
    root.querySelector('[data-done-lede]').textContent =
      bits.length
        ? 'We have your enquiry for ' + bits.join(' on ') + '. The planner will come back within one business day with the room, the timeline and the number.'
        : 'We have your enquiry. The planner will come back within one business day with the room, the timeline and the number.';

    var grid = root.querySelector('[data-done-grid]');
    grid.textContent = '';
    [['Event', values.event_type === OTHER ? (values.event_detail || OTHER) : values.event_type],
     ['Guests', values.guests],
     ['Date', prettyDate(values.date)],
     ['Email', values.email],
     ['Phone', values.phone]
    ].forEach(function (row) {
      if (!row[1]) return;
      /* each pair is its own row so the label sits left and the value right */
      var line = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = row[0];
      dd.textContent = row[1];                    /* every stranger-typed value */
      line.appendChild(dt);
      line.appendChild(dd);
      grid.appendChild(line);
    });

    ask.style.display = 'none';
    done.classList.add('on');
    modal.scrollTop = 0;
  }

  /* ---- submit ---- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    submitTried = true;          /* from here on, blur warns on empties too */
    var firstBad = null;
    controls.forEach(function (el) {
      if (el.closest('.field').hidden) return;
      if (!validate(el, true) && !firstBad) firstBad = el;
    });
    if (firstBad) {
      firstBad.focus();
      showToast('<b>Almost.</b> Check the fields in red');
      return;
    }

    var values = {};
    FIELDS.forEach(function (f) {
      var el = form.querySelector('[name="' + f[1] + '"]');
      values[f[1]] = el ? el.value.trim() : '';
    });
    if (detailField.hidden) values.event_detail = '';

    /* Both keys for every value: the receiving script builds each row by
       looking up the SHEET'S HEADER TEXT, and a snake-key script ignores the
       header names and vice versa. */
    var payload = {};
    FIELDS.forEach(function (f) {
      payload[f[0]] = values[f[1]];
      payload[f[1]] = values[f[1]];
    });
    payload['Site'] = payload['site'] = CFG.siteName || window.location.hostname;
    payload['Page'] = payload['page'] = window.location.href;
    payload['Status'] = payload['status'] = 'New';

    var btn = form.querySelector('[data-msubmit]');
    var label = form.querySelector('[data-submit-label]');

    if (!CFG.leadEndpoint) {
      /* DEMO MODE — nothing is sent. See CFG.leadEndpoint at the top. */
      showDone(values);
      showToast('<b>Demo.</b> This lead would reach your sheet');
      return;
    }

    btn.disabled = true;
    label.textContent = 'Sending';
    fetch(CFG.leadEndpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).then(function () {
      /* The response is opaque — this only proves the request left the
         browser, not that the sheet took the row. */
      showDone(values);
    }).catch(function () {
      showToast('<b>Could not send.</b> Please call ' + CFG.phone);
    }).then(function () {
      btn.disabled = false;
      label.textContent = 'Send request';
    });
  });

  /* ---- reveal only after the theme's preloader clears ---- */
  (function reveal() {
    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      toggle.classList.add('revealed');
    }
    var pre = document.querySelector('.pre, #preloader, [class*="preloader" i]');
    if (pre) {
      var ticks = 0;
      var iv = setInterval(function () {
        var el = document.querySelector('.pre, #preloader, [class*="preloader" i]');
        var gone = !el;
        if (el) {
          var cs = getComputedStyle(el);
          gone = cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1;
        }
        if (gone || ++ticks > 30) { show(); clearInterval(iv); }
      }, 200);
    } else if (document.readyState === 'complete') {
      setTimeout(show, 700);
    } else {
      window.addEventListener('load', function () { setTimeout(show, 700); });
    }
  })();
})();
